import { Tooltip } from 'antd'

interface CustomizedLabelProps {
  x?: number
  y?: number
  fill?: string
  value?: number
}

type TickProps = {
  x?: number
  y?: number
  payload?: CustomizedLabelProps
}
export const CustomizedAxisTickOverall = ({ x, y, payload }: TickProps) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <Tooltip placement='top' title={payload && payload.value}>
        <foreignObject x={-40} y={0} width={50} xHeight={50} height={50} textAnchor='end' transform='rotate(-45)'>
          <div className='w-full truncate text-start'>{payload && payload.value}</div>
        </foreignObject>
      </Tooltip>
    </g>
  )
}
